import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Select from 'react-select';
import getLocale from '../../i18n/getLocale';

class LocationsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      name: null,
      icao_code: null,
      iata_code: null,
      city: null,
      coordinate_lat: null,
      coordinate_long: null,
      shore: null,
      location_type_id: null,
      group: null,
      class: null,
      country_id: null,
      location_types_select: [],
      countries_select: [],
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/local/info/cadastro';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            location_types_select: responseJson.data.location_types_select,
            countries_select: responseJson.data.countries_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
     });
    });
  }


  add(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
      icao_code: this.state.icao_code,
      iata_code: this.state.iata_code,
      city: this.state.city,
      coordinate_lat: this.state.coordinate_lat,
      coordinate_long: this.state.coordinate_long,
      shore: this.state.shore,
      location_type_id: this.state.location_type_id,
      group: this.state.group,
      class: this.state.class,
      country_id: this.state.country_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/local', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/local/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Locais.AdicionarLocal.titulo}</h3>
      <Link to="/locais" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.AdicionarLocal.formulario.Nome}:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.AdicionarLocal.formulario.CodigoICAO}:</label>
            <input type="text" className="form-control" name="icao_code" value={this.state.icao_code} onChange={this.handleChange.bind(this, 'icao_code')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.AdicionarLocal.formulario.Cidade}:</label>
            <input type="text" className="form-control" name="city" value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.AdicionarLocal.formulario.Shore}:</label>
            <Select
              className="form-field-name"
              name="shore"
              value={this.state.shore}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'shore')}
              options={[
                  {value: 'On-Shore', label: this.locale.Locais.AdicionarLocal.formulario.opcoesShore.OnShore},
                  {value: 'Off-Shore', label: this.locale.Locais.AdicionarLocal.formulario.opcoesShore.OffShore},
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.AdicionarLocal.formulario.Latitude}:</label>
            <input type="text" className="form-control" name="coordinate_lat" value={this.state.coordinate_lat} onChange={this.handleChange.bind(this, 'coordinate_lat')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.AdicionarLocal.formulario.Longitude}:</label>
            <input type="text" className="form-control" name="coordinate_long" value={this.state.coordinate_long} onChange={this.handleChange.bind(this, 'coordinate_long')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.AdicionarLocal.formulario.CodigoIATA}:</label>
            <input type="text" name="iata_code" className="form-control" placeholder={this.locale.Locais.AdicionarLocal.formulario.placeholder.CodigoIATA} value={this.state.iata_code} onChange={this.handleChange.bind(this, 'iata_code')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.AdicionarLocal.formulario.Tipo}:</label>
            <Select
              className="form-field-name"
              name="location_type_id"
              value={this.state.location_type_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'location_type_id')}
              options={this.state.location_types_select}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.AdicionarLocal.formulario.Grupo}:</label>
            <Select
              className="form-field-name"
              name="group"
              value={this.state.group}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'group')}
              options={[
                {value: '1', label: '1'},
                {value: '2', label: '2'},
                {value: '3', label: '3'},
              ]}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.AdicionarLocal.formulario.Classe}:</label>
            <Select
              className="form-field-name"
              name="class"
              value={this.state.class}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'class')}
              options={[
                {value: 'A', label: 'A'},
                {value: 'B', label: 'B'},
                {value: 'C', label: 'C'},
                {value: 'D', label: 'D'},
                {value: 'E', label: 'E'},
                {value: 'F', label: 'F'},
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.AdicionarLocal.formulario.Pais}:</label>
            <Select
              className="form-field-name"
              name="country_id"
              value={this.state.country_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'country_id')}
              options={this.state.countries_select}
              required
            />
          </div>
        </div>
        <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.adicionar}</button>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default LocationsAdd;



// WEBPACK FOOTER //
// ./src/Components/Locations/LocationsAdd.js